import { selectInput } from "./form-helpers";
export function userIsLoggedInToPD() {
  return document.cookie
    .split(";")
    .some((item) => item.trim().startsWith("ajs_user_id="));
}

/**
 * @arg {string[]} criteria
 * @returns {string}
 */
export function isPdEmployee(criteria) {
  /** @param {string} id */
  const valOf = (id) => selectInput(id)?.value.trim();
  for (const elId of criteria) {
    if (valOf(elId).endsWith("@pagerduty.com") || valOf(elId).startsWith("pdt"))
      return "Yes";
  }
  return "No";
}
